import { registerChoicesByUrl } from "./registerChoicesByUrl";
import { registerElements } from "./registerElements";
import { registerFunctions } from "./registerFunctions";
import { registerQuestions } from "./registerQuestions";
import { registerRenderers } from "./registerRenderers";
import { registerSerializerExtensions } from "./registerSerializerExtensions";
import { registerValidators } from "./registerValidators";
import {
  registerCommunicationChoiceIcons,
  registerGlassDamageChoiceIcons,
} from "./choiceIcons";

export const registerSurveyExtensions = () => {
  registerSerializerExtensions();
  registerValidators();
  registerElements();
  registerQuestions();
  registerRenderers();
  registerFunctions();
  registerChoicesByUrl();
  registerCommunicationChoiceIcons();
  registerGlassDamageChoiceIcons();
};
